import { InputNumber, InputNumberProps } from "antd";
import { useCallback } from "react";

export interface IInputPrecoProps extends InputNumberProps<number> {

}

export default function InputPreco({
    style,
    min,
    precision,
    controls,
    formatter : formatterParam,
    parser : parserParam,
    ...props
}:IInputPrecoProps) {
    precision = precision === undefined ? 2 : precision;
    min = min === undefined ? 0 : min;
    controls = controls === undefined ? false : controls;

    const formatter = useCallback((value: number | undefined) => {
        value = Number(value);
        if (!value) return '';

        let partes = value.toString().split('.');
        partes[0] = partes[0].replace(/\B(?=(\d{3})+(?!\d))/g, ".");
        if (partes.length > 1 && partes[1].length > precision)
            partes[1] = partes[1].substring(0, precision);

        const valueFormatado = partes.join(',')
        
        return valueFormatado;
    }, [precision]);

    const parser = useCallback((value: string | undefined) => {
        if (!value) return 0;
        return Number(Number.parseFloat(value.replace(/\$\s?|(\.*)/g, "").replace(/(\,{1})/g, ".")).toFixed(precision));
    }, [precision]);

    return <InputNumber<number>
        {...props}
        min={min} 
        precision={precision} 
        controls={controls}
        style={{
            ...style,
            width : style?.width === undefined ? "100%" : style?.width
        }}
        formatter={formatterParam === undefined ? formatter : formatterParam}
        parser={parserParam === undefined ? parser : parserParam}
    />;
}
